import { gql } from '@apollo/client'

/** 积分页-权益卡列表 */
export const GET_INTRGRAL_INFO = gql`
  query getIntegralInfo(
    $eventType: IntegralBillEventType!
    $first: Int = 10
    $offset: Int = 0
  ) {
    copyrightUserInfo {
      integralWalletBalance {
        integralBillList(
          eventType: $eventType
          page: { first: $first, offset: $offset }
        ) {
          edges {
            node {
              billId
              change
              event
              eventTime
              eventType
            }
          }
          pageInfo {
            totalCount
            hasNextPage
          }
        }
      }
    }
  }
`

/** 积分任务详情 */
export const GET_INTEGRAL_TASK_DETAIL = gql`
  query integralTaskDetail {
    integralTaskDetail {
      bonus
      eventName
      eventDesc
      eventType
      icon
      isLimited
      dailyLimit
      eventSort
      rewardDesc
      status
      taskName
      taskType
      totalLimit
      webLink
    }
  }
`

/** 权益卡列表 */
export const INTEGRAL_GET_AIEQUITY_LIST = gql`
  query integralGetAiEquityList {
    accountModule {
      myCard: userMemberCardList {
        cardType
      }
      buyCard: buyMemberCardList {
        cardDesc
        cardType
        name
      }
    }
  }
`

/** 领取积分 */
export const RECEIVE_INTEGRAL = gql`
  mutation receiveIntegral($eventType: Int, $taskType: Int) {
    succed: receiveIntegral(eventType: $eventType, taskType: $taskType)
  }
`
